import { SERVICES } from './constants';
import { Dynamicore } from './dynamicore';

// El catálogo de bancos se consulta una sola vez por sesión y se reutiliza
let banksRequest = null;

export function getBanks() {
  if (!banksRequest) {
    banksRequest = Dynamicore(SERVICES.BANKS)
      .get()
      .then(({ values = [] }) => values)
      .catch((error) => {
        banksRequest = null;
        throw error;
      });
  }

  return banksRequest;
}

// Busca el banco por los 3 primeros dígitos de la CLABE (prefix)
export async function findBankByClabe(clabe) {
  const prefix = String(clabe ?? '').substring(0, 3);

  if (prefix.length < 3) {
    return undefined;
  }

  const banks = await getBanks();

  return banks.find((bank) => bank?.prefix === prefix);
}
